
if ($('#free_cover_selection').length > 0) {
window.addEventListener('ppCartSessionTransactionReady', (e) => {
    let select = document.querySelector('#free_cover_selection');
    if (!select) return;


    e.detail.itemAddition.properties['Free cover'] = select.value
});

$('input[name="Colour"]').on('change', function () {
    const selectedColor = $(this).val(); // get clicked radio value

    // Match with select option and set it selected
    $('#free_cover_selection').val(selectedColor).trigger('change');
});
}

jQuery(document).ready(function ($) {

if ($('.date-remaing').length > 0) {    
    // Get the date value from the hidden input
    var dateString = $('.date-remaing').val();

    // Parse the date string into a Date object
    var targetDate = new Date(dateString.split('-').reverse().join('-'));

    // Get today's date
    var today = new Date();

    // Calculate the difference in time
    var timeDiff = targetDate - today;

    // Convert the time difference to days
    var daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    console.log('*******************');
    console.log(daysLeft);
    console.log('*******************');
    // Update the days left in the DOM
    $('.pre-order_count_day_left').text(daysLeft);

    // RESETS TIMER TO 15 DAYS IF DATE GOES UNDER

    if (daysLeft < 1) {
        var mod = daysLeft * -1;
        $('.pre-order_count_day_left').text(20 - (mod % 20));
    }


    // Extract target and progress values
    var targetText = $('.pre-order_total_quanity').attr('data-preorder_total_quanity');
    var progressText = $('.pre-order_order_count').text();

    // Parse numbers from text
    var target = parseInt(targetText.split(' ')[0]);
    var progress = parseInt(progressText.split(' ')[0]);
    console.log('target ', target);
    console.log('progress ', progress);

    // Calculate percentage
    var percentage = (progress / target) * 100;
    console.log('percentage ', percentage);

    // Set the width of the progress bar
    $('.pre-order_prog-pct').css('width', percentage + '%');
}

function get_order_text() {
    if ($('#pp-dislaimer').length) {
    console.log('PParse: ', $('#pp-dislaimer').text());
    const r = /\d+/g;
    console.log('New Orders', $('#pp-dislaimer').text().match(r));
    updateOrders($('#pp-dislaimer').text().match(r));
    updateOrdersBlock($('#pp-dislaimer').text().match(r));
    } else {
    setTimeout(function () {
        get_order_text();
    }, 300);
    }
}
if ($('body').find('.pp-disclaimer-container')) {
    get_order_text();
}

function updateOrders(ordernum) {
    if (parseInt(ordernum) != 0 && ordernum != null) {
      if ($('.pre-order_order_count').length) {  
        // Extract target and progress values
        var targetText = $('.pre-order_total_quanity').attr('data-preorder_total_quanity');
        var progressText = $('.pre-order_order_count').text();

        // Parse numbers from text
        var target = parseInt(targetText.split(' ')[0]);
        var progress = parseInt(progressText.split(' ')[0]);

        console.log('target ', target);
        console.log('progress ', progress + parseInt(ordernum));
        $('.pre-order_total_order_get').text(progress + parseInt(ordernum));
        $('.pre-order_order_count').text(progress + parseInt(ordernum));

        // Calculate percentage
        var percentage = ((progress + parseInt(ordernum)) / target) * 100;
        console.log('percentage ', percentage);

        // Set the width of the progress bar
        $('.pre-order_prog-pct').css('width', percentage + '%');
      }  
    }
}

function updateOrdersBlock(orderblocknum) {
    if (parseInt(orderblocknum) != 0 && orderblocknum != null) {
        // Extract target and progress values
        var progressText = $('.order_block_count').text();

        // Parse numbers from text
        var progress = parseInt(progressText.split(' ')[0]);

        console.log('progress ', progress + parseInt(orderblocknum));
        $('.order_block_count').text(progress + parseInt(orderblocknum));
    }
}   

});